export default __webpack_public_path__ + "static/media/logo_empiria.4027a544.png";